import { PageController } from '@client/components/_core/layout/PageController';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { type NavTab, useTabNavigation } from '@client/hooks/navigation/useTabNavigation';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Tabs } from 'antd';
import { Receipt } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/financials/billing')({
    staticData: {
        metadata: {
            title: 'Billing and usage',
        },
        ui: {
            icon: Receipt,
            title: 'Billing and usage configuration',
            useTitleForChildren: true,
            menuDescription: 'View billing information and AI usage',
        },
        modules: ['auto-detect', 'document-analyzer'],
        permissions: ['settings:update'],
    },
    component: Billing,
});

const TAB_ROUTES = [
    {
        label: 'Balance',
        path: '/console/$orgId/configuration/financials/billing/balance',
    },
    {
        label: 'Billing Information',
        path: '/console/$orgId/configuration/financials/billing/billing-info',
    },
    {
        label: 'Invoices',
        path: '/console/$orgId/configuration/financials/billing/invoices',
    },
    {
        label: 'Transactions',
        path: '/console/$orgId/configuration/financials/billing/transactions',
    },
    {
        label: 'Usage',
        path: '/console/$orgId/configuration/financials/billing/usage',
    },
] satisfies NavTab[];

function Billing() {
    const orgId = useOrgId();
    const navigate = useNavigate();

    const { activeKey } = useTabNavigation({
        tabs: TAB_ROUTES,
        defaultTabNavigateTo: () =>
            navigate({
                to: TAB_ROUTES[0].path,
                params: {
                    orgId,
                },
            }),
    });

    return (
        <PageController route={Route}>
            <Tabs
                activeKey={activeKey}
                items={TAB_ROUTES.map((route) => ({
                    label: route.label,
                    key: route.path,
                }))}
                onTabClick={(path) => {
                    navigate({
                        to: path,
                        params: {
                            orgId,
                        },
                    });
                }}
            />
            <Outlet />
        </PageController>
    );
}
